import FieldConfig from "../../../proto/field-config";
import FieldProgress from "../../../generic/progress/progress";
import Task from "../../../../model2/task/task";
import FieldTaskProgressItems_TableCell from "./render/table/table-cell";
import {SortDirection} from "../../../../data-structures/sort"
import ItemModel from "../../../../model2/item/item-model"

export default class FieldTaskProgressItems extends FieldProgress {

    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel  = "Progress items"
        this.label      = "Progress items"

        this.renderComponents.tableCell = FieldTaskProgressItems_TableCell
    }

    canEdit(model:Task):boolean {
        return false
    }

    listItemSortFunctions(sort: SortDirection) {
        return {
            functions   : [
                (listItem:ItemModel) => {
                    return listItem.numChildren
                },
                (listItem:ItemModel) => {
                    return !_.isNil(listItem.task.progressSubItems?.done) ? listItem.task.progressSubItems?.done : 0
                },
                (listItem:ItemModel) => {
                    return !_.isNil(listItem.task.progressSubItems?.total) ? listItem.task.progressSubItems?.total : 0
                }
            ],
            directions  : [sort, sort, sort]
        }
    }
}
